"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfTemplateType = void 0;
var PdfTemplateType;
(function (PdfTemplateType) {
    PdfTemplateType["COMMERCIAL_RENEW"] = "COMMERCIAL_RENEW";
    PdfTemplateType["DATA_TABLES"] = "DATA_TABLES";
    PdfTemplateType["FINANCIAL_STATEMENT"] = "FINANCIAL_STATEMENT";
    PdfTemplateType["REVERSE_SUMMARY"] = "REVERSE_SUMMARY";
    PdfTemplateType["UNDERWRITING_REPORT"] = "UNDERWRITING_REPORT";
    PdfTemplateType["CLOSING_COSTS"] = "CLOSING_COSTS";
    PdfTemplateType["CHECKLIST"] = "CHECKLIST";
})(PdfTemplateType = exports.PdfTemplateType || (exports.PdfTemplateType = {}));
